import { render, staticRenderFns } from "./EditExpeditionFee.vue?vue&type=template&id=3c0be990&"
import script from "./EditExpeditionFee.vue?vue&type=script&lang=js&"
export * from "./EditExpeditionFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports